import React from 'react';

export default () => (
    <div className="view-header d-flex align-items-center">
        <header className="text-white">
            <h1 className="h5 title text-uppercase">Flag Metrics</h1>
            <p className="mb-0 subtitle text-nowrap">Flag Metrics</p>
        </header>
  
    </div>
);



// WEBPACK FOOTER //
// ./src/views/flagMetrics/view-header.js